// uiv's <modal> and the wizard overlays are plain <div> overlays, so the browser
// doesn't keep focus inside them. (A native <dialog> can't be used: its top layer
// renders above our <body>-appended uiv popovers, hiding them.) So we contain focus
// ourselves: `containFocus` marks the rest of the page `inert` (removing it from the
// tab order and accessibility tree), and `wrapTabFocus` loops Tab at the edges so
// focus can't slip out to the page or browser chrome (WCAG 2.4.3 / 1.3.2).

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export function containFocus(dialogEl) {
  const inerted = []
  let node = dialogEl
  while (node && node !== document.body && node.parentElement) {
    Array.prototype.forEach.call(node.parentElement.children, sibling => {
      if (
        sibling !== node &&
        !sibling.inert &&
        sibling.tagName !== 'SCRIPT' &&
        sibling.tagName !== 'STYLE'
      ) {
        sibling.inert = true
        inerted.push(sibling)
      }
    })
    node = node.parentElement
  }
  return inerted
}

export function uncontainFocus(inerted) {
  const list = inerted || []
  list.forEach(el => {
    el.inert = false
  })
}

export function wrapTabFocus(event, container) {
  if (event.key !== 'Tab' || !container) return
  // getClientRects(), not offsetParent: offsetParent is null for any element that is
  // itself position: fixed (e.g. ResourcePreviewModal's page-arrow buttons), even when
  // it's rendered and genuinely tabbable — offsetParent wrongly dropped them from this
  // list. getClientRects() stays empty only for elements that truly aren't rendered.
  const focusable = Array.prototype.slice
    .call(container.querySelectorAll(FOCUSABLE_SELECTOR))
    .filter(el => el.getClientRects().length > 0)
  if (!focusable.length) return
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  // The container itself is a valid reverse-Tab boundary too: it's focused directly on
  // mount (e.g. ResourcePreviewModal, so Esc works before the user ever tabs anywhere),
  // but carries tabindex="-1" so it's excluded from `focusable` above.
  if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}
